<template>
    <li
        v-if="shouldRenderItem"
        :class="{
            active: isActive,
            treeview: true,
        }"
    >
        <a href="javascript:;">
            <i v-if="Boolean(icon)" :class="`fa fa-${icon}`" /> {{ label }}
            <span class="pull-right-container" v-if="items.length > 0">
                <i class="fa fa-angle-left pull-right"></i>
            </span>
        </a>
        <ul class="treeview-menu" v-if="items.length > 0">
            <x-sidebar-menu-item
                v-for="(item, index) in items"
                :key="index"
                :icon="item.icon"
                :label="item.label"
                :href="item.href"
                :permission="item.permission"
                :permissions="item.permissions"
                :activePaths="item.activePaths"
            />
        </ul>
    </li>
</template>

<script>
import PermissionMixin from "../mixins/PermissionMixin";
import SidebarMenuMixin from "../mixins/SidebarMenuMixin";
import XSidebarMenuItem from "./XSidebarMenuItem.vue";

export default {
    components: { XSidebarMenuItem },
    computed: {
        activePaths() {
            let paths = [];
            this.items.forEach((item) => {
                if (_.get(item, "activePaths", []).length > 0) {
                    item.activePaths.forEach((path) => paths.push(path));
                    return;
                }
                if (Boolean(item.href)) paths.push(item.href);
            });
            return paths;
        },
        permissions() {
            let permissions = [];
            this.items.forEach((item) => {
                if (Boolean(item.permission)) {
                    permissions.push(item.permission);
                }
                if (Boolean(item.permissions)) {
                    item.permissions.forEach((permission) =>
                        permissions.push(permission)
                    );
                }
            });
            return permissions;
        },
    },
    mixins: [PermissionMixin, SidebarMenuMixin],
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
};
</script>
